import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';

export default function UnderlineTextInput({ ...props }: TextFieldProps) {
    return <TextField {...props} variant="standard" />;
}
